import { storeConfig } from '@/shared/storeConfig';

// ============================================================================
// MOCK FALLBACK — Álbum Copa do Mundo (category_ids: [96])
// ----------------------------------------------------------------------------
// Dados recebidos do CRM enquanto a configuração de badges no Smartico ainda
// está em ajuste. Usado como fallback automático em `loadBadges` quando a API
// não retorna badges (erro ou array vazio).
//
// Quando o Smartico estiver populado em prod, este mock deixa de ser usado
// automaticamente — não há flag de feature, é só fallback "se não tiver dado
// real, mostra o mock".
//
// TODO: remover este array assim que o CRM confirmar que todas as badges
// foram cadastradas e estão sendo entregues pelo getBadges.
// ============================================================================

// Helper pra construir o description no formato JSON-string que o CRM entrega.
// O parse acontece em StickerDetailModal#parseDescription.
function buildDescription(
  text: string,
  fields: Record<string, string>,
): string {
  return JSON.stringify({ Text: text, ...fields });
}

const MOCK_ALBUM_BADGES: TMissionOrBadge[] = [
  // Seção 1537 — Brasil
  {
    id: 62520,
    name: 'BRASIL - Alisson',
    description: buildDescription(
      'Emblema comemorativo do jogador Alisson, exclusivo da Copa do Mundo 2026',
      {
        ELA: '86',
        MAN: '85',
        CHU: '86',
        REF: '89',
        VEL: '56',
        POS: '90',
        Revealed: 'SC Internacional',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/a2610df3e0b392fef64acb-ALISSON_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 1,
    category_ids: [96],
    custom_data: '/vip/missions?open=61846',
  } as unknown as TMissionOrBadge,
  {
    id: 62521,
    name: 'BRASIL - G. Magalhães',
    description: buildDescription(
      'Emblema comemorativo do jogador G. Magalhães, exclusivo da Copa do Mundo 2026',
      {
        RIT: '64',
        FIN: '44',
        PAS: '64',
        CON: '65',
        DEF: '88',
        FÍS: '84',
        Revealed: 'Avai FC',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/a2f0bed031fc17c0efe0bd-GABRIELMAGALHAES_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 2,
    category_ids: [96],
    custom_data: '/vip/missions?open=61853',
  } as unknown as TMissionOrBadge,
  {
    id: 62522,
    name: 'BRASIL - Marquinhos',
    description: buildDescription(
      'Emblema comemorativo do jogador Marquinhos, exclusivo da Copa do Mundo 2026',
      {
        RIT: '78',
        FIN: '56',
        PAS: '75',
        CON: '74',
        DEF: '89',
        FÍS: '80',
        Revealed: 'SC Corinthians',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/18eff8a6413f640328c6cb-MARQUINHOS_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 3,
    category_ids: [96],
    custom_data: '/vip/missions?open=61845',
  } as unknown as TMissionOrBadge,
  {
    id: 62523,
    name: 'BRASIL - Casemiro',
    description: buildDescription(
      'Emblema comemorativo do jogador Casemiro, exclusivo da Copa do Mundo 2026',
      {
        RIT: '36',
        FIN: '74',
        PAS: '76',
        CON: '69',
        DEF: '80',
        FÍS: '76',
        Revealed: 'São Paulo FC',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/364783968a6057998ded4d-CASEMIRO_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 4,
    category_ids: [96],
    custom_data: '/vip/missions?open=61886',
  } as unknown as TMissionOrBadge,
  {
    id: 62525,
    name: 'BRASIL - B. Guimarães',
    description: buildDescription(
      'Emblema comemorativo do jogador B. Guimarães, exclusivo da Copa do Mundo 2026',
      {
        RIT: '36',
        FIN: '74',
        PAS: '76',
        CON: '69',
        DEF: '80',
        FÍS: '76',
        Revealed: 'Osasco Audax',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/43ca7caa8e0d60d1f1d141-BRUNOGUIMARAES_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 5,
    category_ids: [96],
    custom_data: '/vip/missions?open=61897',
  } as unknown as TMissionOrBadge,
  {
    id: 62526,
    name: 'BRASIL - L. Paquet​​á',
    description: buildDescription(
      'Emblema comemorativo do jogador L. Paquetá, exclusivo da Copa do Mundo 2026',
      {
        RIT: '68',
        FIN: '78',
        PAS: '78',
        CON: '84',
        DEF: '69',
        FÍS: '75',
        Revealed: 'CR Flamengo',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/b0680d71f6aa226f65c154-PAQUETA_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 6,
    category_ids: [96],
    custom_data: '/vip/missions?open=62131',
  } as unknown as TMissionOrBadge,
  {
    id: 62527,
    name: 'BRASIL - G. Martinelli',
    description: buildDescription(
      'Emblema comemorativo do jogador G. Martinelli, exclusivo da Copa do Mundo 2026',
      {
        RIT: '90',
        FIN: '77',
        PAS: '75',
        CON: '83',
        DEF: '46',
        FÍS: '72',
        Revealed: 'Ituano FC',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/f21053a27da72b0f8ee630-GABRIELMARTINELLI_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 7,
    category_ids: [96],
    custom_data: '/vip/missions?open=62133',
  } as unknown as TMissionOrBadge,
  {
    id: 62528,
    name: 'BRASIL - Rayan',
    description: buildDescription(
      'Emblema comemorativo do jogador Rayan, exclusivo da Copa do Mundo 2026',
      {
        RIT: '83',
        FIN: '77',
        PAS: '72',
        CON: '76',
        DEF: '35',
        FÍS: '76',
        Revealed: 'Vasco da Gama',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/a6431c8e29e3312a0c9df8-RAYAN_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 8,
    category_ids: [96],
    custom_data: '/vip/missions?open=62135',
  } as unknown as TMissionOrBadge,
  {
    id: 62532,
    name: 'BRASIL - Raphinha',
    description: buildDescription(
      'Emblema comemorativo do jogador Raphinha, exclusivo da Copa do Mundo 2026',
      {
        RIT: '91',
        FIN: '84',
        PAS: '85',
        CON: '87',
        DEF: '53',
        FÍS: '75',
        Revealed: 'Vitória de Guimarães SC',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/a55b54b1e3d0b6258792be-RAPHINHA_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 9,
    category_ids: [96],
    custom_data: '/vip/missions?open=62136',
  } as unknown as TMissionOrBadge,
  {
    id: 62533,
    name: 'BRASIL - Endrick',
    description: buildDescription(
      'Emblema comemorativo do jogador Endrick, exclusivo da Copa do Mundo 2026',
      {
        RIT: '87',
        FIN: '77',
        PAS: '62',
        CON: '78',
        DEF: '30',
        FÍS: '68',
        Revealed: 'SE Palmeiras',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/9eed21d4e1ecce2d81a2a7-ENDRICK_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 10,
    category_ids: [96],
    custom_data: '/vip/missions?open=62137',
  } as unknown as TMissionOrBadge,
  {
    id: 62534,
    name: 'BRASIL - Vini Jr.',
    description: buildDescription(
      'Emblema comemorativo do jogador Vini Jr., exclusivo da Copa do Mundo 2026',
      {
        RIT: '95',
        FIN: '84',
        PAS: '81',
        CON: '91',
        DEF: '29',
        FÍS: '69',
        Revealed: 'CR Flamengo',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/0a05428d9732542d13be7f-VINIJR_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 11,
    category_ids: [96],
    custom_data: '/vip/missions?open=62200',
  } as unknown as TMissionOrBadge,
  {
    id: 62535,
    name: 'BRASIL - Neymar Jr.',
    description: buildDescription(
      'Emblema comemorativo do craque Neymar Jr., exclusivo da Copa do Mundo 2026',
      {
        RIT: '76',
        FIN: '79',
        PAS: '85',
        CON: '88',
        DEF: '37',
        FÍS: '53',
        Revealed: 'Santos FC',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/9a832ce4d91f2f26808eb0-NEYMARJR_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1537,
    position: 12,
    category_ids: [96],
    custom_data: '/vip/missions?open=61892',
  } as unknown as TMissionOrBadge,

  // Seção 1538 — Mundo
  {
    id: 62536,
    name: 'MUNDO - A. Hakimi',
    description: buildDescription(
      'Emblema comemorativo do jogador A. Hakimi, exclusivo da Copa do Mundo 2026',
      {
        RIT: '92',
        FIN: '79',
        PAS: '82',
        CON: '83',
        DEF: '82',
        FÍS: '79',
        Revealed: 'Real Madrid CF',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/cd0105a432bdc0edbad94a-HAKIMI_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 13,
    category_ids: [96],
    custom_data: '/vip/missions?open=62208',
  } as unknown as TMissionOrBadge,
  {
    id: 62538,
    name: 'MUNDO - M. Depay',
    description: buildDescription(
      'Emblema comemorativo do jogador M. Depay, exclusivo da Copa do Mundo 2026',
      {
        RIT: '82',
        FIN: '82',
        PAS: '81',
        CON: '85',
        DEF: '30',
        FÍS: '80',
        Revealed: 'PSV Eindhoven',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/63051029f6f1efe509f43b-M.DEPAY_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 14,
    category_ids: [96],
    custom_data: '/vip/missions?open=62211',
  } as unknown as TMissionOrBadge,
  {
    id: 62539,
    name: 'MUNDO - K. De Bruyne',
    description: buildDescription(
      'Emblema comemorativo do jogador K. De Bruyne, exclusivo da Copa do Mundo 2026',
      {
        RIT: '66',
        FIN: '83',
        PAS: '92',
        CON: '84',
        DEF: '65',
        FÍS: '72',
        Revealed: 'KRC Genk',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/9718c4868fba60e5c57047-DEBRUYNE_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 15,
    category_ids: [96],
    custom_data: '/vip/missions?open=62217',
  } as unknown as TMissionOrBadge,
  {
    id: 62540,
    name: 'MUNDO - H. Kane',
    description: buildDescription(
      'Emblema comemorativo do jogador H. Kane, exclusivo da Copa do Mundo 2026',
      {
        RIT: '64',
        FIN: '92',
        PAS: '83',
        CON: '82',
        DEF: '48',
        FÍS: '82',
        Revealed: 'Tottenham Hotspur',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/ec1c37a0915a08eee1bb6f-H.KANE_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 16,
    category_ids: [96],
    custom_data: '/vip/missions?open=62218',
  } as unknown as TMissionOrBadge,
  {
    id: 62541,
    name: 'MUNDO - E. Haaland',
    description: buildDescription(
      'Emblema comemorativo do jogador E. Haaland, exclusivo da Copa do Mundo 2026',
      {
        RIT: '86',
        FIN: '91',
        PAS: '70',
        CON: '80',
        DEF: '45',
        FÍS: '88',
        Revealed: 'Bryne FK',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/21f88645d51df7549870c0-HAALAND_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 17,
    category_ids: [96],
    custom_data: '/vip/missions?open=61891',
  } as unknown as TMissionOrBadge,
  {
    id: 62542,
    name: 'MUNDO - M. Mbapp​​é ',
    description: buildDescription(
      'Emblema comemorativo do jogador K. Mbappé, exclusivo da Copa do Mundo 2026',
      {
        RIT: '97',
        FIN: '90',
        PAS: '81',
        CON: '92',
        DEF: '37',
        FÍS: '76',
        Revealed: 'AS Monaco',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/c9638b22040ec4f94dfbe3-MBAPPE_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 18,
    category_ids: [96],
    custom_data: '/vip/missions?open=62247',
  } as unknown as TMissionOrBadge,
  {
    id: 62543,
    name: 'MUNDO - L. Yamal',
    description: buildDescription(
      'Emblema comemorativo do jogador L. Yamal, exclusivo da Copa do Mundo 2026',
      {
        RIT: '85',
        FIN: '81',
        PAS: '86',
        CON: '90',
        DEF: '23',
        FÍS: '53',
        Revealed: 'FC Barcelona',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/5517bcaf881eb161b76bd2-L.YAMAL_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 19,
    category_ids: [96],
    custom_data: '/vip/missions?open=62332',
  } as unknown as TMissionOrBadge,
  {
    id: 62544,
    name: 'MUNDO - O. Dembél​​​é ',
    description: buildDescription(
      'Emblema comemorativo do jogador O. Dembél​, exclusivo da Copa do Mundo 2026',
      {
        RIT: '91',
        FIN: '88',
        PAS: '83',
        CON: '93',
        DEF: '50',
        FÍS: '69',
        Revealed: 'Stade Rennais',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/71bde7480249af3becf114-DEMBELE_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 20,
    category_ids: [96],
    custom_data: '/vip/missions?open=62444',
  } as unknown as TMissionOrBadge,
  {
    id: 62545,
    name: 'MUNDO - C. Ronaldo',
    description: buildDescription(
      'Emblema comemorativo do jogador C. Ronaldo, exclusivo da Copa do Mundo 2026',
      {
        RIT: '76',
        FIN: '88',
        PAS: '76',
        CON: '80',
        DEF: '34',
        FÍS: '76',
        Revealed: 'Sporting CP',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/8e3221b386dc8694862aa3-C.RONALDO_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 21,
    category_ids: [96],
    custom_data: '/vip/missions?open=62449',
  } as unknown as TMissionOrBadge,
  {
    id: 62546,
    name: 'MUNDO - L. Messi',
    description: buildDescription(
      'Emblema comemorativo do craque L. Messi, exclusivo da Copa do Mundo 2026',
      {
        RIT: '78',
        FIN: '85',
        PAS: '85',
        CON: '99',
        DEF: '33',
        FÍS: '64',
        Revealed: 'FC Barcelona',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/4c7a8c77193463af29bba8-L.MESSI_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1538,
    position: 22,
    category_ids: [96],
    custom_data: '/vip/missions?open=62457',
  } as unknown as TMissionOrBadge,

  // Seção 1539 — Lendas
  {
    id: 62547,
    name: 'LENDA - R. Gaucho',
    description: buildDescription(
      'Emblema comemorativo da lenda Ronaldinho Gaúcho, exclusivo da Copa do Mundo 2026',
      {
        RIT: '91',
        FIN: '89',
        PAS: '90',
        CON: '95',
        DEF: '38',
        FÍS: '80',
        Revealed: 'Grêmio FBPA',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/726d4ed703ae2bfe7afe48-RONALDINHO_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1539,
    position: 23,
    category_ids: [96],
    custom_data: '/vip/missions?open=62468',
  } as unknown as TMissionOrBadge,
  {
    id: 62549,
    name: 'LENDA - Romário',
    description: buildDescription(
      'Emblema comemorativo da lenda Romário, exclusivo da Copa do Mundo 2026',
      {
        RIT: '97',
        FIN: '95',
        PAS: '87',
        CON: '96',
        DEF: '46',
        FÍS: '65',
        Revealed: 'Vasco Gama',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/052a6f1309bc63535a5f1b-ROMARIO_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1539,
    position: 24,
    category_ids: [96],
    custom_data: '/vip/missions?open=62466',
  } as unknown as TMissionOrBadge,
  {
    id: 62550,
    name: 'LENDA - Garrincha',
    description: buildDescription(
      'Emblema comemorativo da lenda Garrincha, exclusivo da Copa do Mundo 2026',
      {
        RIT: '89',
        FIN: '85',
        PAS: '92',
        CON: '94',
        DEF: '40',
        FÍS: '66',
        Revealed: 'Botafogo',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/276a51c6c9bff261b992d4-GARRINCHA_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1539,
    position: 25,
    category_ids: [96],
    custom_data: '/vip/missions?open=62464',
  } as unknown as TMissionOrBadge,
  {
    id: 62554,
    name: 'LENDA - R. Fênomeno',
    description: buildDescription(
      'Emblema comemorativo da lenda Ronaldo Fênomeno, exclusivo da Copa do Mundo 2026',
      {
        RIT: '92',
        FIN: '92',
        PAS: '79',
        CON: '92',
        DEF: '42',
        FÍS: '73',
        Revealed: 'Cruzeiro',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/3e19e29970440723f6a56c-RONALDO_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1539,
    position: 26,
    category_ids: [96],
    custom_data: '/vip/missions?open=62462',
  } as unknown as TMissionOrBadge,
  {
    id: 62555,
    name: 'LENDA - Pel​é ',
    description: buildDescription(
      'Emblema comemorativo do Rei Pelé, exclusivo da Copa do Mundo 2026',
      {
        RIT: '94',
        FIN: '96',
        PAS: '92',
        CON: '95',
        DEF: '60',
        FÍS: '75',
        Revealed: 'Santos FC',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/34e096f6a849554a9199cb-REIPELE_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1539,
    position: 27,
    category_ids: [96],
    custom_data: '/vip/missions?open=62459',
  } as unknown as TMissionOrBadge,

  // Seção 1540 — Seleções Campeãs
  {
    id: 62557,
    name: 'Campeã: Seleção 1.958',
    description: buildDescription(
      'Emblema comemorativo do elenco campeão em 1958, exclusivo da Copa do Mundo 2026',
      {
        GOL: 'Gilmar',
        DEF: 'Nilton Santos',
        MEI: 'Garrincha',
        ATA: 'Pelé',
        Local: 'Suécia',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/2556ec252b72489f6e0eda-BRASIL1958_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1540,
    position: 28,
    category_ids: [96],
    custom_data: '/vip/missions?open=62341',
  } as unknown as TMissionOrBadge,
  {
    id: 62558,
    name: 'Bicampeã: Seleção 1.962',
    description: buildDescription(
      'Emblema comemorativo do elenco campeão em 1962, exclusivo da Copa do Mundo 2026',
      {
        GOL: 'Gilmar',
        DEF: 'Nilton Santos',
        MEI: 'Garrincha',
        ATA: 'Vavá',
        Local: 'Chile',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/249b072b1f83497444bf20-BRASIL1962_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1540,
    position: 29,
    category_ids: [96],
    custom_data: '/vip/missions?open=62396',
  } as unknown as TMissionOrBadge,
  {
    id: 62560,
    name: 'Tricampeã: Seleção 1.970',
    description: buildDescription(
      'Emblema comemorativo do elenco campeão em 1970, exclusivo da Copa do Mundo 2026',
      {
        GOL: 'Felix',
        DEF: 'C.A. Torres',
        MEI: 'Rivellino',
        ATA: 'Pelé',
        Local: 'México',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/1ababa65a54eaf884224f2-BRASIL1970_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1540,
    position: 30,
    category_ids: [96],
    custom_data: '/vip/missions?open=62412',
  } as unknown as TMissionOrBadge,
  {
    id: 62567,
    name: 'Tetracampeã: Seleção 1.994',
    description: buildDescription(
      'Emblema comemorativo do elenco campeão em 1970, exclusivo da Copa do Mundo 2026',
      {
        GOL: 'Taffarel',
        DEF: 'Aldair',
        MEI: 'Dunga',
        ATA: 'Romário',
        Local: 'EUA',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/82e85255acd85756c490cd-BRASIL1994_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1540,
    position: 31,
    category_ids: [96],
    custom_data: '/vip/missions?open=62433',
  } as unknown as TMissionOrBadge,
  {
    id: 62568,
    name: 'Pentacampeã: Seleção 2.002',
    description: buildDescription(
      'Emblema comemorativo do elenco campeão em 2002, exclusivo da Copa do Mundo 2026',
      {
        GOL: 'Marcos',
        DEF: 'Cafú',
        MEI: 'Rivaldo',
        ATA: 'Ronaldo Fênomeno',
        Local: 'Japão e Coreia do Sul',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/db48f55fce0a74023e6974-BRASIL2002_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1540,
    position: 32,
    category_ids: [96],
    custom_data: '/vip/missions?open=62437',
  } as unknown as TMissionOrBadge,
  {
    id: 62570,
    name: 'Hexacampeã: Seleção 2.026',
    description: buildDescription(
      'Emblema comemorativo do elenco de 2026, exclusivo da Copa do Mundo 2026',
      {
        GOL: 'Alisson',
        DEF: 'Marquinhos',
        MEI: 'Neymar',
        ATA: 'Endrick',
        Local: 'EUA, Canadá e México',
      },
    ),
    image:
      'https://d146b4m7rkvjkw.cloudfront.net/8470bd553c69da50475f5b-BRASIL2026_1x.webp',
    is_completed: false,
    is_locked: false,
    type: 'badge',
    custom_section_id: 1540,
    position: 33,
    category_ids: [96],
    custom_data: '/vip/missions?open=62442',
  } as unknown as TMissionOrBadge,
];

export const useSmarticoBadges = defineStore(
  'smarticoBadges',
  () => {
    const { debugLog } = useSmarticoConfigs();

    const badges = ref<TMissionOrBadge[]>([]);
    const isCallbackRegistered = ref<boolean>(false);

    function handleBadgesUpdate(updatedBadges: TMissionOrBadge[]) {
      if (!updatedBadges || !Array.isArray(updatedBadges)) {
        debugLog('⚠️ onUpdate callback received invalid data for badges');

        return;
      }

      debugLog(
        `🔄 Badges updated via callback onUpdate: ${updatedBadges.length} badges`,
      );

      updatedBadges.forEach((updatedBadge) => {
        const index = badges.value.findIndex((b) => b.id === updatedBadge.id);

        if (index !== -1) {
          const newBadges = [...badges.value];

          newBadges[index] = updatedBadge;
          badges.value = newBadges;
        } else {
          badges.value.push(updatedBadge);
        }
      });
    }

    function registerUpdateCallback() {
      if (isCallbackRegistered.value) return;

      try {
        if (window?._smartico?.api?.registerBadgesUpdateCallback) {
          window._smartico.api.registerBadgesUpdateCallback(handleBadgesUpdate);
          isCallbackRegistered.value = true;
          debugLog('✅ Badges update callback registered successfully');
        }
      } catch (err: any) {
        debugLog(`⭕️ ~ registerBadgesUpdateCallback ~ ${err.toString()}`);
      }
    }

    async function loadBadges() {
      try {
        const result = await window._smartico.api.getBadges({
          onUpdate: handleBadgesUpdate,
        });

        const list = Array.isArray(result) ? result : [];

        if (list.length === 0) {
          debugLog(
            `🧪 getBadges retornou vazio — usando mock do álbum (${MOCK_ALBUM_BADGES.length} badges)`,
          );
          badges.value = MOCK_ALBUM_BADGES;
        } else {
          badges.value = list;
        }

        registerUpdateCallback();
      } catch (err: any) {
        debugLog(`⭕️ ~ getBadges ~ ${err.toString()}`);
        debugLog(
          `🧪 getBadges falhou — usando mock do álbum (${MOCK_ALBUM_BADGES.length} badges)`,
        );
        badges.value = MOCK_ALBUM_BADGES;
      }
    }

    function loadMockBadges() {
      badges.value = MOCK_ALBUM_BADGES;
    }

    return {
      badges,
      loadBadges,
      loadMockBadges,
    };
  },

  storeConfig,
);
